// @flow
import _ from 'lodash';

import type { TRootStore } from '../../types';

export const getWaiversListIds = (state: TRootStore) =>
	_.get(state, 'leagues.waiver_list.ordered_ids', {});

export default getWaiversListIds;


// WEBPACK FOOTER //
// ./src/modules/selectors/league/getWaiversListIds.js